import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { logsRestHooks } from '../../../../../../store/Memberships/LogsSlice';
import LogPresenter from '../../../../../../presenters/Membership/LogPresenter';
import { useFetchStatus } from '../../../../../../utils/fetchStatusUtils';
import ListSkeleton from '../../../../../../components/Skeletons/ListSkeleton';
import {
  LIST_SKELETON_HEIGHT,
  LIST_SKELETON_WIDTH,
} from '../../../../../../pages/constants';

const Logs = (props) => {
  const { membershipId } = props;
  const {
    loadLogs,
    loadResetLogs,
    logs: { loadingStatus, items: logs },
  } = logsRestHooks.use();

  const { isFulfilled } = useFetchStatus(loadingStatus);

  useEffect(() => {
    loadLogs(membershipId);
    return () => {
      loadResetLogs();
    };
  }, []);

  if (!isFulfilled) {
    return (
      <ListSkeleton height={LIST_SKELETON_HEIGHT} width={LIST_SKELETON_WIDTH} />
    );
  }

  return (
    <table className="logs-table">
      <thead>
        <tr>
          <th className="cell">Created at</th>
          <th className="cell">Event</th>
        </tr>
      </thead>
      <tbody>
        {logs.map((log) => (
          <tr key={LogPresenter.id(log)}>
            <td className="cell">{LogPresenter.createdAtReadable(log)}</td>
            <td className="cell">{LogPresenter.eventTypeReadable(log)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Logs;

Logs.propTypes = {
  membershipId: PropTypes.string.isRequired,
};
